import { CONFIG } from 'src/config-global';

import { SvgColor } from 'src/components/svg-color';

export const Svg = (name: string) => (
  <SvgColor src={`${CONFIG.site.basePath}/assets/icons/lms-icon/${name}.svg`} />
);
